import React, { Component } from "react";
import { connect } from "react-redux";
import {Container, Col, Row, FormGroup, Form, Input, Button, Alert} from 'reactstrap';
import Header from "./share/Header";
import {FaFileExcel}  from 'react-icons/fa';
import {reportes} from "../actions";
import Loading from "./share/Loading";

class Reportes extends Component {

    constructor(props){
        super(props);
        this.state = {
            tipo_filtro: '',
            filtro: '',
            urlReport: ''
        };
        this.getReportesCultivo = this.getReportesCultivo.bind(this);
        this.getReportesFiltro = this.getReportesFiltro.bind(this);
    }

    getReportesFiltro(e){
        e.preventDefault();
        this.props.getReportes(this.state.tipo_filtro, this.state.filtro);
        this.resetForms();
    }

    getReportesCultivo(e){
        e.preventDefault();
        this.props.getReportes('', '');
        this.resetForms();
    }

    resetForms(){
        this.setState({
            tipo_filtro: '',
            filtro: ''
        });
    }

    componentDidUpdate(prevProps){
        if(!!this.props.report){
            let csvURL = window.URL.createObjectURL(this.props.report);
            if(this.props.report !== prevProps.report){
                this.setState({urlReport: csvURL});
            }
        }
    }


    render(){

        const {loadingReport, errorReport, report} = this.props;

        return(
            <div>
                <Header/>
                <Container className = 'reportes'>
                    <Row>
                        <h1 className="tituloGeneral mt-4 mb-4 text-center w-100 font-italic font-weight-bold">Reportes</h1>
                    </Row>
                    <Row className="contenedor ml-1 mr-1">
                        <Col className="contenedorFormularios" md={{size: 6, offset: 0}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}}>
                            <Row>
                                <h2 className="text-center mb-3 font-italic w-100">Generar reportes</h2>
                            </Row>

                            {
                                (!!loadingReport) ? <Loading/> :


                                <div className="formularios">

                                    <Form className="w-100" onSubmit={this.getReportesFiltro}>
                                        <FormGroup className="form-group">
                                            <Row>
                                                <Col>
                                                    <h4>Reporte por trabajador</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="8" sm="10" md="9">
                                                    <Input type="number" name="numero_identificacion" id="numero_identificacion" placeholder="Cédula" onChange={e => this.setState({ filtro: e.target.value, tipo_filtro: 'trabajador' })}/>
                                                </Col>
                                                <Col xs="4" sm="2" md="3" className="text-center">
                                                    <Button type="submit">Generar</Button>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Form>
                                    <Form className="w-100" onSubmit={this.getReportesFiltro}>
                                        <FormGroup className="form-group">
                                            <Row>
                                                <Col>
                                                    <h4>Reporte por zona</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="8" sm="10" md="9">
                                                    <Input type="number" name="numero_zona" id="numero_zona" placeholder="No. zona" onChange={e => this.setState({ filtro: e.target.value, tipo_filtro: 'zona' })}/>
                                                </Col>
                                                <Col xs="4" sm="2" md="3" className="text-center">
                                                    <Button type="submit">Generar</Button>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Form>
                                    <Form className="w-100" onSubmit={this.getReportesCultivo}>
                                        <FormGroup className="form-group">
                                            <Row>
                                                <Col>
                                                    <h4>Reporte del cultivo</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" sm="12" md="12" className="text-center text-center">
                                                    <Button type="submit">Generar reporte general</Button>
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                    </Form>
                                </div>
                            }
                        </Col>

                        <Col className="contenedorReportes" md={{size: 6, offset: 0}} sm={{size: 10, offset: 1}} xs={{size: 10, offset: 1}}>
                            <Row>
                                <Col md={{size: 10, offset: 1}} className="mt-5">
                                    {
                                        (!!errorReport) ?
                                            <Alert color="danger">
                                                <Container fluid>
                                                    <h3 className="text-center">No hay resultados para la búsqueda</h3>
                                                </Container>
                                            </Alert> : ''
                                    }
                                    {
                                        (!!report) ?
                                            <Alert color="">
                                                <Container fluid className="text-center">
                                                    <h4>Se ha generado el reporte</h4>
                                                    <FaFileExcel size={100} className="mt-3 mb-3 w-100" color="green"/>
                                                    <a href={window.URL.createObjectURL(report)} download='reporte.csv'>
                                                        <Button color="primary">Descargar</Button>
                                                    </a>
                                                </Container>
                                            </Alert> : ((report === null && errorReport === null) ?
                                                <Alert color="">
                                                    <Container fluid className="text-center">
                                                        <h4>Seleccione una de las opciones de la izquierda</h4>
                                                    </Container>
                                                </Alert> : ''
                                            )
                                    }
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loadingReport:  state.reportes.loadingReport,
        errorReport: state.reportes.errorReport,
        report: state.reportes.report
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getReportes: (tipo_filtro, filtro) => {
            return dispatch(reportes.getReportes(tipo_filtro, filtro));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reportes);